var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map",attrs:{"id":"map-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }